"use client";

import { ReactNode, useId, useState } from "react";

import styles from "./Tooltip.module.scss";

export type TooltipRule = {
  condition: boolean;
  content: string;
};

interface TooltipProps {
  rules: TooltipRule[];
  children: ReactNode;
  className?: string;
}

export const Tooltip = ({ children, rules, className = "" }: TooltipProps) => {
  const tooltipId = useId();
  const [visible, setVisible] = useState(false);

  // the first matching rule wins
  const activeRule = rules.find((rule) => rule.condition);
  const content = activeRule?.content;

  if (!content) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div
      className={`${styles["tooltip-box"]} ${className}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      aria-describedby={visible ? tooltipId : undefined}
    >
      {children}
      {visible && (
        <div id={tooltipId} role="tooltip" className={styles["tooltip"]}>
          {content}
        </div>
      )}
    </div>
  );
};
